import { debounce } from 'lodash';
import React, { useMemo, useCallback, useEffect, MouseEvent } from 'react';
import styled from 'styled-components';

interface DebounceButtonProps {
  waitMS: number;
  onClick: (event?: MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const NoTapHighlightButton = styled.button`
  -webkit-tap-highlight-color: transparent;
`;

const DebounceButton = ({ waitMS, onClick, children, style }: DebounceButtonProps) => {
  const debounceClickEvent = useMemo(() => {
    return debounce(onClick, waitMS, { leading: true, trailing: false });
  }, [onClick, waitMS]);

  const handleClick = useCallback(
    (event?: MouseEvent<HTMLButtonElement>) => {
      debounceClickEvent(event);
    },
    [debounceClickEvent],
  );

  useEffect(() => {
    return () => {
      debounceClickEvent.cancel();
    };
  }, [debounceClickEvent]);

  return (
    <NoTapHighlightButton
      type="button"
      onClick={(event?: MouseEvent<HTMLButtonElement>) => handleClick(event)}
      style={style}
    >
      {children}
    </NoTapHighlightButton>
  );
};

export default DebounceButton;
